import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../../services/authentication.service';
import { CommonService } from '../../../../services/common.service';
import { ProfileService } from '../../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-contact-search',
  templateUrl: './contact-search.component.html',
  styleUrls: ['./contact-search.component.scss']
})
export class ContactSearchComponent implements OnInit {

    pagecode: string = "gistec-contact-search";
    module: string = "gistec";
    accessdenied: boolean = false;
    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {

    }

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
    }

    email: string = "";

    users: any[] = [];

    searchEnter(evt: any) {
        if (evt.keyCode === 13) {
            // Cancel the default action, if needed
            event!.preventDefault();
            // Trigger the button element with a click
            this.searchForUserByEmail();
        }
    }

    searchForUserByEmail() {
        this.profileService.searchForUserByEmail(this.email).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        this.users = res.data;
                        console.log("searchForUserByEmail", this.users);
                    }
                }
            },
            (err: any) => {
                console.error("searchForUserByEmail err", err);
            }
        );
    }

    activateDeactivateUser(isActive: any, user: any) {
        this.profileService.activateDeactivateUser(isActive, user.id).subscribe(
            (res: any) => {
                if (res) {
                    user.isActive = !user.isActive;
                }
            },
            (err: any) => {
                console.error("searchForUserByEmail err", err);
            }
        );
        //
    }
}
